




















































































import { Component, Watch } from 'vue-property-decorator';
import Weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/de';
import dayjs from 'dayjs';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import {
  CheckSquareIcon,
  ChevronDownIcon,
  CircleIcon,
  FileTextIcon,
  TrashIcon,
} from 'vue-feather-icons';
import { IAnnouncement, INotification, NotificationEvent } from 'admiral-core';
import { NotificationApi } from '@/services/NotificationApi';
import { Util } from '@/utils/Util';
import AdmiralAvatar from '@/components/common/AdmiralAvatar.vue';
import AnnouncementModal from '@/modals/AnnouncementModal.vue';
import NotificationItem from '@/components/common/NotificationItem.vue';
import { AnnouncementApi } from '@/services/AnnouncementApi';

dayjs.extend(Weekday);
dayjs.locale('de');

@Component({
  name: 'notification-overview',
  components: {
    NotificationItem,
    AnnouncementModal,
    AdmiralAvatar,
    FileTextIcon,
    ChevronDownIcon,
    TrashIcon,
    CheckSquareIcon,
    CircleIcon,
  },
})
export default class NotificationOverview extends mixins(BaseMixin) {
  isContentHovered = false;

  notifications: INotification[] = [];

  hoveredA: Record<string, boolean> = {};

  selectedAnnouncement: null | IAnnouncement = null;
  hasRecentlyNew = false;

  hover(id: string) {
    this.hoveredA[id] = true;
  }

  unhover(id: string) {
    this.hoveredA[id] = false;
  }

  get newNotifications() {
    return this.$store.state.socketConnection.notifications;
  }

  async mounted() {
    await this.reload();
  }

  async reload() {
    try {
      const response = await NotificationApi.getNotifications();
      this.notifications = response.data;
      if (this.unreadNotifications.length > 0) {
        this.bounceNewNotification();
      }
      this.updateTitle();
    } catch (e) {
      console.log(e);
    }
  }

  bounceNewNotification() {
    this.hasRecentlyNew = true;
    setTimeout(() => {
      this.hasRecentlyNew = false;
    }, 2500);
  }

  get hasNewAnnouncement() {
    return this.$store.state.socketConnection.announcement;
  }

  @Watch('hasNewAnnouncement', { deep: true, immediate: true })
  async watchHasNewAnnouncement() {
    if (this.hasNewAnnouncement) {
      await this.reload();
      this.$store.dispatch('socketConnection/updateAnnouncement', null);
    }
  }

  @Watch('newNotifications', { deep: true, immediate: true })
  watchNewNotifications() {
    if (this.newNotifications) {
      this.notifications = this.uniqueNotifications().sort((a: INotification, b: INotification) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      });
    }
  }

  uniqueNotifications() {
    const combined = [...this.notifications, ...this.newNotifications];
    return combined.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
  }

  get unreadNotifications() {
    return this.notifications.filter((notification) => !notification.readAt);
  }

  @Watch('unreadNotications')
  setNotifactionCountOnTitle() {
    this.updateTitle();
  }

  updateTitle() {
    document.title = document.title.replace(/\(*.\)/g, '');

    if (this.unreadNotifications.length > 0) {
      document.title = `(${this.unreadNotifications.length}) ${document.title}`;
    }
  }

  payload(notification: INotification) {
    switch (notification.event) {
      case NotificationEvent.Announcement:
        return (notification as INotification<NotificationEvent.Announcement>).payload;
    }
  }
  async markAsRead(notification: INotification) {
    try {
      notification.readAt = new Date();
      await NotificationApi.update(notification.id, {
        readAt: notification.readAt,
      });
      await this.reload();
    } catch (e) {
      console.log(e);
    }
  }
  async markAsUnread(notification: INotification) {
    try {
      notification.readAt = null;
      await NotificationApi.update(notification.id, {
        readAt: notification.readAt,
      });
      await this.reload();
    } catch (e) {
      console.log(e);
    }
  }

  async open(notification: INotification) {
    if (notification.event === NotificationEvent.Announcement) {
      try {
        const response = await AnnouncementApi.getAnnouncement(
          (notification as INotification<NotificationEvent.Announcement>).announcement!.id,
        );

        this.selectedAnnouncement = response.data;
        (this.$refs['view-announcement-modal'] as any).$refs['view-announcement'].show();
      } catch (e) {
        console.log(e);
      }
    }
  }

  formatCreatedAt(date: Date) {
    return Util.formatDate(date);
  }

  get unreadStr() {
    return this.unreadNotifications.length > 9 ? '9+' : this.unreadNotifications.length;
  }
}
